<template>
  <div class="css-grid battery-order-history-view__order">

    <Product v-for="(product, index) in order.products" :index="index" :key="index" :product="product" :order="order"></Product>

    <div class="css-grid battery-order-history-view__product battery-order-history-view__product--total">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div class="h-right-align">Total:</div>
      <div class="h-center-align">{{ order.total }}</div>
    </div>
    <hr />
    <div></div>

  </div>
</template>

<script>
  import Product from './Product.vue';

  export default {
    name: 'Order',
    components: {
      Product,
    },
    props: ['order', 'index'],
  };
</script>
